import type {
  NotificationSettings,
  NotificationSections,
  UpdateSettingsDTO,
} from '@api/notifications';

/** Начальные значения применяются только к отсутствующим полям, сохраняя false. */
export const settingsSections = (
  settings?: NotificationSettings,
): NotificationSections => {
  const sections = settings?.sections;
  const attention = sections?.['attention-queue'];
  const simple = (name: 'analytics-reports' | 'tasks') => ({
    enabled: sections?.[name]?.enabled ?? true,
    channels: {
      telegram: sections?.[name]?.channels?.telegram ?? true,
      max: sections?.[name]?.channels?.max ?? false,
    },
  });
  return {
    'attention-queue': {
      enabled: attention?.enabled ?? false,
      p1: {
        telegram: attention?.p1?.telegram ?? true,
        max: attention?.p1?.max ?? false,
      },
      p2: {
        telegram: attention?.p2?.telegram ?? true,
        max: attention?.p2?.max ?? false,
      },
    },
    'analytics-reports': simple('analytics-reports'),
    tasks: simple('tasks'),
  };
};

/** Снимок формы для сравнения с прочитанными серверными настройками. */
export interface NotificationSettingsDraft {
  sections: NotificationSections;
  reportWorkspaceSids: string[];
}

/** Сохранить только изменённые секции/подписки, не переписывая соседние настройки. */
export const settingsChanges = (
  current: NotificationSettingsDraft,
  previous: NotificationSettingsDraft,
): UpdateSettingsDTO => {
  const dto: UpdateSettingsDTO = {};
  const sectionKeys = [
    'attention-queue',
    'analytics-reports',
    'tasks',
  ] as const;
  for (const key of sectionKeys) {
    if (
      JSON.stringify(current.sections[key]) ===
      JSON.stringify(previous.sections[key])
    )
      continue;
    if (key === 'attention-queue') {
      dto.sections = {
        ...dto.sections,
        'attention-queue': current.sections['attention-queue'],
      };
    } else {
      dto.sections = {...dto.sections, [key]: current.sections[key]};
    }
  }
  if (
    JSON.stringify(current.reportWorkspaceSids) !==
    JSON.stringify(previous.reportWorkspaceSids)
  ) {
    dto.reportWorkspaceSids = current.reportWorkspaceSids;
  }
  return dto;
};
